module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerHeavyItalic.93a1ed59.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerHeavyItalic.otf
// module id = 1067
// module chunks = 0